"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProducts = void 0;
const react_1 = require("react");
const filter_formatters_1 = require("./table-data-source-formatters/filter.formatters");
const sort_formatter_1 = require("./table-data-source-formatters/sort.formatter");
const utils_1 = require("./utils");
const use_get_products_1 = require("../../../client/product/hooks/use-get-products");
const context_1 = require("../../../context");
const feature_flags_1 = require("../../../../feature-flags");
const hooks_1 = require("../../../../hooks");
const store_1 = require("../../../../store");
const useProducts = ({ tableFilter, tableSort, searchTerm, isListViewMode, labelsSelection: { excludedLabelColumns, excludedMeasureColumns, selectAllMode, }, reviewStatus, productTreeNodeId, pageSize, selectedAttributeNode, chunkSize, includeLabelExplanation, skipLabelValidation = true, }) => {
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const isMeasureEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.Measures);
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const { isNodeOrRelatedNodeReEnriching } = (0, context_1.useCatalogActivityProgressContext)();
    // Fetch locked count if node is part of any re-enriching hierarchy
    // (current node, ancestors, or descendants - locked products can appear in any of these cases)
    const shouldFetchLockedCount = isNodeOrRelatedNodeReEnriching(productTreeNodeId, { onlyRealTasks: true });
    const sort = (0, react_1.useMemo)(() => (0, sort_formatter_1.convertReduxSortModelToGraphQL)(tableSort, reviewStatus), [tableSort, reviewStatus]);
    const productTextAttributesFilter = (0, react_1.useMemo)(() => (isListViewMode
        ? (0, utils_1.getProductTextAttributesFilter)(excludedLabelColumns, selectAllMode)
        : utils_1.PRODUCT_BASE_ATTRIBUTES_FILTER), [isListViewMode, excludedLabelColumns, selectAllMode]);
    const productMeasuresFilter = (0, react_1.useMemo)(() => (isMeasureEnabled && isListViewMode ? (0, utils_1.getProductMeasuresFilter)(excludedMeasureColumns, selectAllMode) : null), [isMeasureEnabled, isListViewMode, excludedMeasureColumns, selectAllMode]);
    const filter = (0, react_1.useMemo)(() => (0, filter_formatters_1.convertReduxFilterModelToGraphQL)({
        tableFilter,
        selectedAttributeNode,
        search: searchTerm,
        reviewStatus,
    }), [searchTerm, selectedAttributeNode, tableFilter, reviewStatus]);
    const productsResponse = (0, use_get_products_1.useGetProducts)({
        catalogId,
        productTreeNodeId,
        skipMeasures: !isMeasureEnabled,
        filter,
        sort,
        productTextAttributesFilter,
        productMeasuresFilter,
        reviewStatus,
        pageSize,
        chunkSize,
        includeLabelExplanation,
        shouldFetchLockedCount,
        skipLabelValidation,
    });
    return productsResponse;
};
exports.useProducts = useProducts;
